import axios from "axios";

export const axiosAuthInstance = axios.create({
  baseURL: import.meta.env.FUZEBOX_API_URL,
});
